<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Flag / Region / Korea</title>
    <defs>
      <circle id="path-1" cx="12" cy="12" r="12"></circle>
      <polygon id="path-3" points="0 0 24 0 24 24 0 24"></polygon>
    </defs>
    <g
      id="Flag-/-Region-/-Korea"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask" fill-rule="nonzero"></g>
      <g id="kr" mask="url(#mask-2)">
        <mask id="mask-4" fill="white">
          <use xlink:href="#path-3"></use>
        </mask>
        <g id="Path"></g>
        <g id="Group" mask="url(#mask-4)">
          <g transform="translate(-5.625000, -0.046875)">
            <polygon
              id="Path"
              fill="#FFFFFF"
              fill-rule="evenodd"
              points="34.246875 24.028125 0.01875 24.028125 0.01875 0.028125 34.246875 0.028125"
            ></polygon>
            <path
              d="M17.4328125,12.046875 C17.4328125,14.9593141 15.0718141,17.3203125 12.159375,17.3203125 C9.24693589,17.3203125 6.8859375,14.9593141 6.8859375,12.046875 C6.8859375,9.13443589 9.24693589,6.7734375 12.159375,6.7734375 C15.0718141,6.7734375 17.4328125,9.13443589 17.4328125,12.046875 L17.4328125,12.046875 Z"
              id="Path"
              fill="#FFFFFF"
              fill-rule="evenodd"
            ></path>
            <path
              d="M24.046875,12.35625 C24.1118232,14.8568716 22.8285047,17.1961422 20.6952009,18.46578 C18.561897,19.7354177 15.9146655,19.7354177 13.7813616,18.46578 C11.6480578,17.1961422 10.3647393,14.8568716 10.4296875,12.35625 C10.3647393,9.85562838 11.6480578,7.51635783 13.7813616,6.24672005 C15.9146655,4.97708226 18.561897,4.97708226 20.6952009,6.24672005 C22.8285047,7.51635783 24.1118232,9.85562838 24.046875,12.35625 L24.046875,12.35625 Z"
              id="Path"
              fill="#C70000"
              fill-rule="evenodd"
            ></path>
            <path
              d="M3.309375,5.971875 L7.228125,1.4390625 L8.1609375,2.240625 L4.2375,6.778125 L3.309375,5.971875 Z M4.59375,7.0828125 L8.5125,2.55 L9.4453125,3.346875 L5.521875,7.8890625 L4.59375,7.0828125 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#000000"
              fill-rule="evenodd"
              points="3.309375 5.971875 7.228125 1.4390625 8.1609375 2.240625 4.2375 6.778125"
            ></polygon>
            <path
              d="M3.309375,5.971875 L7.228125,1.4390625 L8.1609375,2.240625 L4.2375,6.778125 L3.309375,5.971875 Z M5.90625,8.221875 L9.825,3.6796875 L10.7578125,4.4859375 L6.834375,9.0234375 L5.90625,8.221875 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#000000"
              fill-rule="evenodd"
              points="3.309375 5.971875 7.228125 1.4390625 8.1609375 2.240625 4.2375 6.778125"
            ></polygon>
            <path
              d="M3.309375,5.971875 L7.228125,1.4390625 L8.1609375,2.240625 L4.2375,6.778125 L3.309375,5.971875 Z M27.159375,1.434375 L31.05,6 L30.1125,6.796875 L26.221875,2.23125 L27.159375,1.434375 Z M24.5484375,3.6609375 L28.4390625,8.2265625 L27.5015625,9.0234375 L23.6109375,4.4578125 L24.5484375,3.6609375 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fill-rule="evenodd"
              points="25.2 6.290625 28.875 3.1125 29.5640625 3.909375 25.6265625 7.44375 25.190625 6.290625"
            ></polygon>
            <path
              d="M29.728125,17.484375 L25.959375,21.975 L25.0359375,21.20625 L28.8046875,16.715625 L29.728125,17.484375 Z M25.865625,2.5359375 L29.75625,7.1015625 L28.8234375,7.8984375 L24.9375,3.328125 L25.865625,2.5359375 Z M31.0078125,18.5484375 L27.234375,23.0390625 L26.30625,22.2703125 L30.0796875,17.7796875 L31.0078125,18.5484375 Z M28.425,16.4015625 L24.65625,20.8921875 L23.7328125,20.1234375 L27.5015625,15.6328125 L28.425,16.4015625 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
            <path
              d="M10.528125,11.1421875 C10.74375,12.8765625 11.0578125,14.8078125 13.725,15.0046875 C14.7234375,15.065625 16.66875,14.7703125 17.334375,12.0421875 C18.215625,9.4265625 20.85,8.6765625 22.6453125,10.0921875 C23.671875,10.7578125 23.953125,11.8125 24.01875,12.609375 C23.9390625,15.140625 22.4765625,17.34375 20.60625,18.328125 C18.45,19.6078125 15.46875,19.6359375 12.8578125,17.6953125 C11.68125,16.59375 10.0359375,14.5546875 10.528125,11.1421875 Z"
              id="Path"
              fill="#3D5897"
              fill-rule="evenodd"
            ></path>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fill-rule="evenodd"
              points="26.0625 17.41875 29.746875 20.5875 29.0625 21.384375 24.9796875 18.01875 26.0578125 17.41875"
            ></polygon>
            <polygon
              id="Path"
              fill="#000000"
              fill-rule="evenodd"
              points="5.5359375 16.790625 9.4265625 21.3515625 8.4890625 22.1484375 4.5984375 17.5875"
            ></polygon>
            <polygon
              id="Path"
              fill="#FFFFFF"
              fill-rule="evenodd"
              points="4.865625 20.5453125 8.55 17.3625 9.2390625 18.159375 5.3015625 21.6984375 4.865625 20.540625"
            ></polygon>
            <path
              d="M6.8296875,15.6890625 L10.7203125,20.25 L9.7828125,21.046875 L5.8921875,16.4859375 L6.8296875,15.6890625 Z M4.21875,17.915625 L8.109375,22.4765625 L7.171875,23.2734375 L3.28125,18.7125 L4.21875,17.915625 Z"
              id="Shape"
              fill="#000000"
              fill-rule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>